import Network from '../../../client/network'
import AwesomeNotifications from 'awesome-notifications'

export default class Reservation
{
	static picker()
	{
		const picker = $('__datetime')

		picker.daterangepicker({
			locale             : {
				format     : 'YYYY-MM-DD HH:mm',
				daysOfWeek : ['日', '月', '火', '水', '木', '金', '土'],
				monthNames : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
				cancelLabel: 'キャンセル',
				applyLabel : '適用',
			},
			timePickerIncrement: 30,
			autoUpdateInput    : false,
			singleDatePicker   : true,
			timePicker         : true,
			timePicker24Hour   : true,
			minYear            : 2021,
		})

		picker.on('apply.daterangepicker', function(event, picker)
		{
			$(this).val(picker.startDate.format('YYYY-MM-DD HH:mm'))
		})
	}

	static sorter()
	{
		$('.__sorter').tablesorter({
			sortList: [[0, 0]],
		})
	}

	static pick(year, month, day, time, cell, logged_in, coupon_identifier = '')
	{
		if($(cell).hasClass('_legend-outside') || $(cell).hasClass('_legend-filled')) return

		if(!logged_in)
		{
			alert('ログインをお願いします')
			return
		}

		const modal = $('#modal').clone()
		modal.removeClass('hidden')

		const date = $(cell).data('time') || `${month}月${day}日 ${time}`
		modal.find('#modal_time').text(date)

		modal.find('input[name="time"]').val(`${year}-${month}-${day} ${time}`)
		modal.find('input[name="reservation"]').val($(cell).data('reservation'))

		if($(cell).hasClass('_legend-reserved'))
		{
			const coupon_option = modal.find(`select[name="coupon"] option[value="${$(cell).data('coupon')}"]`)[0]
			if(coupon_option) coupon_option.setAttribute('selected', 'selected')

			modal.find('#modal_question').addClass('hidden')
			modal.find('#modal_submit').addClass('hidden')

			modal.find('#modal_reserved').removeClass('hidden')
			modal.find('#modal_cancel').removeClass('hidden')

			const coupon = modal.find('select[name="coupon"]')
			coupon.prop('disabled', true)

			const input = modal.find('#modal_coupon')

			input.attr('name', 'coupon')
			input.val(coupon.val())
		}
		else
		{
			if(coupon_identifier)
			{
				const coupon_option = modal.find(`select[name="coupon"] option[value="${coupon_identifier}"]`)[0]
				if(coupon_option) coupon_option.setAttribute('selected', 'selected')
			}
		}

		const notification = new AwesomeNotifications()
		notification.modal(modal[0].outerHTML)
	}

	static send_reservation(form, confirm_page = false)
	{
		try
		{
			const cancel = !$(form).find('#modal_cancel').hasClass('hidden')

			const message = cancel ? 'キャンセル' : '登録'
			if(!confirm(`予約を${message}しますか？`)) return false

			const data = new FormData(form)
			data.append('_action', cancel ? 'cancel' : 'add')

			Network.post(location.pathname, data, (success) =>
			{
				if(success)
				{
					$('#awn-popup-wrapper')[0].click()

					setTimeout(() =>
					{
						if(confirm_page) window.location.href = window.location.href.replace(/\/reservation\//, '/confirm/') + `/${form.time.value}`
						else window.location.reload()
					}, 2000)
				}
			})
		}
		catch(exception)
		{
			console.error(exception.message)
		}

		return false
	}

	static check_required(form)
	{
		let agreed = true

		$(form).find('._required').each(function()
		{
			if(!this.checked)
			{
				agreed = false

				const title = $(this).data('agree')
				alert(`${title}に同意する必要があります`)
			}
		})

		return agreed
	}
}
